import { baseAxios } from './Axios';
//Components
import { getDate } from '../components/DataParcial';
import { TemplateRanking, TemplateMyPosition } from '../components/Templates';
import { miliSeconds, minutes } from '../components/CalcTime';
import { removeAccents } from '../components/RemoveAccents';

const Ranking = (()=>{
    
    //request
    const request = async(category)=>{
        const response = await baseAxios.get(`/get-ranking?category=${category}`);
        return response.data;
    }

    //Dependencies
    const _RankingDependencies = ()=>{
        const date = getDate();
        const currentDate = new Date();
        const rankingTime = document.querySelectorAll('.date-ranking');
        rankingTime.forEach((data)=>{
            data.textContent = `${date} de ${currentDate.getFullYear()}`;
        });
    }

    //Config
    const _RankingConfig = ()=>{
        const buttons = document.querySelectorAll('#ranking-category .btn');
        const loader = document.querySelector('.loader');
        const block = document.querySelector('#ranking-block');
        const error = document.querySelector('#ranking-block .error-message');
        const articles = document.querySelectorAll('#ranking-block article');
        const containerRanking = document.querySelector('#container-ranking');
        const setCategory = document.querySelector('#ranking-set-category');
        const search = document.querySelector('#search-ranking');
        const totalResults = document.querySelector('#count-results');
        const currentPostion = document.querySelector('#render-current-position');
        //Event change
        buttons.forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                const parent = e.target.closest('.ranking');
                const value = e.target.dataset.value;
                //Set color
                value == 'Legendario' && containerRanking.classList.add('Legendario');
                value == 'Profesional' && containerRanking.classList.add('Profesional');
                //Set category
                setCategory.textContent = `Categoría ${value}`;
                //Enable and disable sections
                setTimeout(()=>{
                    parent.classList.add('hidden');
                    block.classList.remove('hidden');
                },1000);
                loader.classList.remove('disabled');
                //Request
                request(value)
                    .then(res=>{
                        const { ranking, user } = res;
                        const container = document.querySelector('#render-ranking');
                        console.log(ranking);
                        ranking && ranking.forEach((data, indice)=>{
                            const { name, totalcorrects, totalquestions, totaltime, position } = data;
                            const correctAnswers = `${totalcorrects}/${totalquestions}`;
                            //Calc time
                            let getSeconds = miliSeconds(totaltime);
                            //Render template and validate if is winner
                            if(indice == 0){
                                const template = TemplateRanking('winner', `🏆 ${position}`, name, correctAnswers, minutes(getSeconds));
                                container.append(template);
                            }else{
                                const template = TemplateRanking('', indice + 1, name, correctAnswers, minutes(getSeconds));
                                container.append(template);
                            }
                        });
                        //Render current position
                        if(user?.totaltime){
                            const { position, name, lastname, totalquestions, totalcorrects, totaltime } = user;
                            //Calc time
                            let getSeconds = miliSeconds(totaltime);
                            const template = TemplateMyPosition(position, name, lastname, totalquestions, totalcorrects, minutes(getSeconds));
                            currentPostion.append(template);
                        }else{
                            currentPostion.classList.add('hidden');
                        }
                        //Validate ranking
                        if(ranking?.length == 0 || !ranking){
                            error.classList.add('active');
                            articles.forEach((article, indice)=>{
                                indice > 0 && article.classList.add('hidden');
                            });
                        }
                        //Disable loader
                        setTimeout(()=>{
                            loader.classList.add('disabled');
                        },1500);
                        //Search
                        search.addEventListener('keyup', (e)=>{
                            //Create regular exp and filter items
                            const value = e.target.value;
                            const remove = removeAccents(value);
                            const reg = new RegExp(remove);
                            const results = ranking.filter((item)=>{
                                return reg.test(removeAccents(item.name));
                            });
                            //Remove items
                            const allItems = document.querySelectorAll('#render-ranking .item-body');
                            allItems.forEach((item)=>{
                                item.remove();
                            });
                            //Render items
                            results.forEach((data, indice)=>{
                                const { name, totalcorrects, totalquestions, totaltime, position } = data;
                                const correctAnswers = `${totalcorrects}/${totalquestions}`;
                                //Calc time
                                let segundos = miliSeconds(totaltime);
                                const template = TemplateRanking('', position, name, correctAnswers, minutes(segundos));
                                container.append(template);
                            });
                            //Show results
                            const resultsFilter = document.querySelectorAll('#render-ranking .item-body').length;
                            console.log(resultsFilter);
                            totalResults.classList.remove('hidden');
                            if(resultsFilter > 0){
                                totalResults.textContent = `Se han encontrado ${resultsFilter} resultados`;
                            }else{
                                totalResults.textContent = `No se han encontrado resultados`;
                            }
                        });
                    }).catch(err=>{
                        //Disable loader
                        setTimeout(()=>{
                            loader.classList.add('disabled');
                        },1500);
                        console.log(err); 
                    });
            });
        });

    }

    /*
    *Return child functions in a objects
    */
    return{
        setHandleEvent: function(){
            try { 
                _RankingDependencies(); 
            } catch (error) { 
                console.log(error);
            }
            try { 
                _RankingConfig(); 
            } catch (error) { 
                console.log(error); 
            }
        }
    }
})();

/*
*Load global functions
*/
const loadRankingHandlers = ()=>{
    Ranking.setHandleEvent();
}

export { loadRankingHandlers }